// Referidos de un cliente en el cajón (`retail-wizard-business`): listar con `retail.customer.read`
// scope RETAILER; agregar y corregir con `retail.customer.referral.write`. No hay borrado.
import { apiFetch } from '../../client';
import type { components } from './retail-wizard.gen';

const BASE_URL = import.meta.env.VITE_API_RETAIL_WIZARD_BASE_URL;

type Schemas = components['schemas'];

export type BackofficeReferralCapture = Schemas['BackofficeReferralCapture'];
export type BackofficeCustomerReferral = Schemas['BackofficeCustomerReferral'];
/** Un premio de una promo de referido; `rewards` ausente = promociones no respondió. */
export type BackofficeReferralReward = Schemas['BackofficeReferralReward'];

export type BackofficeReferralStatus = BackofficeCustomerReferral['status'];
export type BackofficeReferralSource = BackofficeReferralCapture['source'];
export type BackofficeReferredBy = Schemas['BackofficeReferredBy'];

export interface BackofficeCustomerReferrals {
    referrals: BackofficeCustomerReferral[];
    /** `null` si el cliente no llegó recomendado. */
    referredBy: BackofficeReferredBy | null;
}

export type CreateCustomerReferralInput =
    Schemas['CreateBackofficeReferralsRequest']['referrals'][number];
export type UpdateCustomerReferralInput = Schemas['UpdateBackofficeReferralRequest'];
export type SavedCustomerReferral = Schemas['CustomerReferral'];

/** `?value=` solo cuando la cadena se elige (mesa central); el Admin VL usa la de su token. */
function scopeQuery(retailerId: string | undefined): string {
    return retailerId ? `?${new URLSearchParams({ value: retailerId }).toString()}` : '';
}

function referralsPath(retailCustomerId: string): string {
    return `/backoffice/customers/${encodeURIComponent(retailCustomerId)}/referrals`;
}

export async function listCustomerReferrals(
    retailCustomerId: string,
    retailerId?: string,
): Promise<BackofficeCustomerReferrals> {
    const data = await apiFetch<Partial<BackofficeCustomerReferrals> | null>(
        `${referralsPath(retailCustomerId)}${scopeQuery(retailerId)}`,
        { baseUrl: BASE_URL },
    );
    return { referrals: data?.referrals ?? [], referredBy: data?.referredBy ?? null };
}

export async function createCustomerReferrals(
    retailCustomerId: string,
    referrals: CreateCustomerReferralInput[],
    retailerId?: string,
): Promise<SavedCustomerReferral[]> {
    const body: Schemas['CreateBackofficeReferralsRequest'] = { referrals };
    const data = await apiFetch<{ referrals?: SavedCustomerReferral[] } | null>(
        `${referralsPath(retailCustomerId)}${scopeQuery(retailerId)}`,
        { baseUrl: BASE_URL, method: 'POST', body: JSON.stringify(body) },
    );
    return data?.referrals ?? [];
}

export async function updateCustomerReferral(
    retailCustomerId: string,
    referralId: string,
    patch: UpdateCustomerReferralInput,
    retailerId?: string,
): Promise<SavedCustomerReferral | null> {
    const data = await apiFetch<{ referral?: SavedCustomerReferral } | null>(
        `${referralsPath(retailCustomerId)}/${encodeURIComponent(referralId)}${scopeQuery(retailerId)}`,
        { baseUrl: BASE_URL, method: 'PUT', body: JSON.stringify(patch) },
    );
    return data?.referral ?? null;
}
